import React, { useState, useEffect } from 'react';
import { WarningCircle, X } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Bandeau visible UNIQUEMENT sur le preview (test/dev) — pas en production.
 * Redirige les visiteurs égarés vers le vrai site `autogere.ca`.
 *
 * Détection : hostname contient "preview.emergentagent.com".
 */
const PreviewWarningBanner = () => {
  const { t } = useLanguage();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('preview_banner_dismissed') === '1';
    if (dismissed) setHidden(true);
  }, []);

  if (typeof window === 'undefined') return null;
  const host = window.location.hostname || '';
  const isPreview = host.includes('preview.emergentagent.com') || host.includes('.preview.');
  if (!isPreview || hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem('preview_banner_dismissed', '1');
    setHidden(true);
  };

  return (
    <div
      data-testid="preview-warning-banner"
      className="bg-red-700 text-white text-center py-2 px-4 text-sm font-semibold sticky top-0 z-[60] shadow-md"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 flex-wrap">
        <WarningCircle size={18} weight="fill" />
        <span>
          {t('pwa.previewBanner1')}{' '}
          <a
            href="https://autogere.ca"
            data-testid="preview-banner-prod-link"
            className="underline font-bold hover:text-red-100"
          >
            https://autogere.ca
          </a>{' '}
          {t('pwa.previewBanner2')}
        </span>
        <button
          type="button"
          onClick={dismiss}
          data-testid="preview-banner-dismiss"
          className="ml-2 p-1 rounded hover:bg-red-800 transition-colors"
          aria-label="Masquer"
        >
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default PreviewWarningBanner;
